//import
import axios, { plainAxios } from "../../helpers/api";
import { userConstants } from "../../constant";
import { userServices } from "../../services";
import { API_BASE_URL } from "../../stories/Constant";
import { WS_BASE_URI } from "../../stories/Constant";
import { alertActions } from "./alertAction";
import { create_UUID } from "../../helpers/utils";
import { store } from "../store";
import { trackPromise } from "react-promise-tracker";
export const userActions = {
  login,
  logout,
  register,
  verifyUserOTP,
  forgotPassword,
  resetPassword,
  changePassword,
  getUserProfile,
  updateUserProfile,
  getAllProducts,
  getSingleProducts,
  addToCart,
  updateCart,
  removeFromCart,
  getCartDetails,
  setAddress,
  getAddress,
  getEditAddress,
  editAddress,
  deleteAddress,
  setDefaultAddress,
  checkOut,
  getOrderItem,
  getProductData,
  getSellerOrders,
  getNewArrival,
  searchQuery,
  getSellerDashboard,
  sellerRegistration,
  sellerOrderSearch,
  processOrder,
  setOrderStatus,
  productListing,
  listChatableUser,
  searchChatUserQuery,
  getChat,
  sendChat,
  createCampaign,
  getCampaign,
  campaignActions,
  getAdvert,
  clickedAdvert,
  getWishList,
  postWishList,
  deleteWishList,
  postProductReview,
  postSellerReviewResponse,
  setStarRating,
  trackOrder,
  ratedProduct,
  getBuyerTransactions,
  getRefund,
  recentlyViewed,
  contactSeller,
  reportSeller,
  getInbox,
  getCategory,
  getCategoryDetail,
  editProduct,
  getProduct,
  getAllJobs,
  applyForJob,
  getJobPostings,
  getJobPostingDetail,
  submitJobApplication,
  getAllUsers,
  uploadNDA,
  getNDA,
  getNDAPackages,
  getNDAPrice,
  purchaseNDA,
  sendNDA,
  getPurchasedNDA,
  getNDAProposal,
  handleNDA,
  getCampaignReg,
  currencyConverter,
  getUserTimezone,
  updateUserTimezone,
  addSponsorShipProduct,
  getAllSponsorshipProducts,
  fundProduct,
  removeData,
  getSellerVerification,
  submitSellerVerification,
  getFilterOptions,
  getCampaignUpdates,
  createCampaignUpdate,
  getSponsorshipProductDetail,
  getCampaignRewards,
  getSellerBoostStatus,
  boostProduct,
  getBoostAnalytics,
  getBuyerDashboardStats,
  getSellerDashboardStats,
  getSellerProductViews,
  getSellerPerformance,
  getRevenueShareOffer,
  createRevenueShareOffer,
  revenueShareAction,
  detectCountry,
  saveDetectedCountryToProfile,
  submitQuoteRequest,
  getBuyerQuotes,
  getSellerQuotes,
  respondToQuote,
  validateCoupon,
  getSellerOnboardingStatus,
  dismissSellerOnboarding,
  completeSellerOnboarding,
  getFeaturedSellers,
  fetchProductQuestions,
  postProductQuestion,
  answerProductQuestion,
  getSellerVacation,
  updateSellerVacation,
  getCampaignRating,
  getCampaignExtensionStatus,
  requestCampaignExtension,
  getSellerBundles,
  createSellerBundle,
  deleteSellerBundle,
  addBundleToCart,
  getWishlistShareStatus,
  toggleWishlistShare,
  getSharedWishlist,
  fetchPriceHistory,
  getSavedSearches,
  saveSearch,
  deleteSavedSearch,
  toggleSavedSearchNotify,
  joinWaitlist,
  leaveWaitlist,
  getWaitlistStatus,
  getUserWaitlist,
  getSellerWaitlistDemand,
  waitlistDeposit,
  getExclusiveWindow,
  getBuyerLoyalty,
  getSellerGoals,
  updateSellerGoals,
  getSellerDisputes,
  respondToDispute,
  getBuyerDisputes,
  createBuyerDispute,
  getDisputeDetail,
  uploadDisputeEvidence,
  appealDispute,
  requestArbitration,
  getArbitrationStatus,
  payArbitrationBond,
  confirmArbitrationBond,
  getSellerCollections,
  createSellerCollection,
  updateSellerCollection,
  deleteSellerCollection,
  fetchProductCertifications,
  uploadProductCertification,
  getBuyerOnboardingStatus,
  dismissBuyerOnboarding,
  tfaVerifyLogin,
  getShippingEstimate,
  clearShippingEstimate,
  getAdminShippingRates,
  createShippingRate,
  updateShippingRate,
  deleteShippingRate,
  getBuyerReturns,
  createReturnRequest,
  getSellerReturns,
  respondToReturn,
  confirmReturnReceipt,
  uploadReturnEvidence,
  getSubscriptions,
  createSubscription,
  updateSubscription,
  cancelSubscription,
  getPriceAlerts,
  setPriceAlert,
  removePriceAlert,
  getPriceAlertStatus,
  getHomepageAd,
  recordAdClick,
  getBestSellers,
  getRecommendedProducts,
  getActiveCampaigns,
  getSuccessStories,
  getOrderTracking,
  updateOrderTracking,
  confirmDelivery,
  getBuyerRfqs,
  createRfq,
  getRfqDetail,
  getRfqQuotes,
  getManufacturerRfqs,
  submitRfqQuote,
  acceptRfqQuote,
  rejectRfqQuote,
  signRfqNda,
  getRfqPriceSuggestion,
  getBuyerOnboardingWizardStatus,
  updateBuyerOnboardingStep,
  completeBuyerOnboarding,
  getSellerAnalytics,
  getFeaturedBundles,
  getFrequentlyBoughtTogether,
  getRelatedProductsSeller,
  updateSellerBundle,
  showUpsellPopup,
  hideUpsellPopup,
  bulkUpdateOrderStatus,
  updateOrderNotes,
  reorderItems,
  cancelOrder,
  getCancelStatus,
  sellerExportOrders,
  getWishlistFolders,
  createWishlistFolder,
  updateWishlistFolder,
  deleteWishlistFolder,
  moveWishlistItem,
  bulkAddToCart,
  getSellerWishlistAnalytics,
  getLoyaltyTransactions,
  redeemLoyaltyPoints,
  getLoyaltyDashboard,
};

function uploadNDA(file) {
  return (dispatch) => {
    axios.post(`${API_BASE_URL}/uploadnda/`, file).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success(res.data.message));
      }
    });
  };
}

function login(payload) {
  let { email, user_type } = payload;
  return (dispatch) => {
    dispatch(loginRequest({ email, user_type }));
    userServices.login(payload).then(
      (user) => {
        // If 2FA is required, dispatch special action instead of login success
        if (user?.requires_2fa) {
          dispatch({ type: userConstants.TFA_REQUIRED, temp_token: user.temp_token });
          return;
        }
        dispatch(loginSuccess(user));
        // Sync preferred language from account
        if (user?.preferred_language && user.preferred_language !== '') {
          import('i18next').then(i18n => {
            i18n.default.changeLanguage(user.preferred_language);
          }).catch(() => {});
        }
        // Fetch cart details immediately after login so cart state is current
        if (user?.cart_token) {
          dispatch(getCartDetails(user.cart_token));
        }
      },
      (error) => {
        //User account has not been verified
        dispatch(loginFailure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function loginRequest(user) {
    return { type: userConstants.REQUEST_SUCCESS, user };
  }
  function loginSuccess(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function loginFailure(error) {
    return { type: userConstants.REQUEST_FAILURE, error };
  }
}

function tfaVerifyLogin(payload) {
  return (dispatch) => {
    userServices.tfaVerifyLogin(payload).then(
      (user) => {
        dispatch({ type: userConstants.TFA_VERIFY_SUCCESS });
        dispatch({ type: userConstants.LOGIN_SUCCESS, user });
        if (user?.cart_token) {
          dispatch(getCartDetails(user.cart_token));
        }
      },
      (error) => {
        dispatch(alertActions.error(error?.message || "Invalid 2FA code."));
      }
    );
  };
}

function logout() {
  userServices.logout();
  return { type: userConstants.LOGOUT };
}

function register(payload) {
  let { email, name, user_type } = payload;
  return (dispatch) => {
    dispatch(registerRequest(email, name, user_type));
    userServices
      .register(payload)
      .then((user) => {
        dispatch(registerSuccess(user));
        dispatch(
          alertActions.success("Registration successful,Verify your account")
        );
      })
      .catch((error) => {
        dispatch(registerFailure(error));
        dispatch(alertActions.error(error));
      });
  };
  function registerRequest(user) {
    return { type: userConstants.REQUEST_SUCCESS, user };
  }
  function registerSuccess(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function registerFailure(error) {
    return { type: userConstants.REQUEST_FAILURE, error };
  }
}

function getUserProfile() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/user/profile`).then((res) => {
        dispatch({
          type: userConstants.GET_USER_PROFILE,
          profile: res.data.user,
        });
      })
    );
  };
}

function updateUserProfile(payload) {
  return (dispatch) => {
    trackPromise(
      axios
        .put(`${API_BASE_URL}/user/profile`, payload)
        .then((res) => {
          if (res.data.status) {
            dispatch(alertActions.success("profile updated successfully"));
            dispatch({
              type: userConstants.GET_USER_PROFILE,
              profile: res.data.user,
            });
          } else {
            throw res.data.error;
          }
        })
        .catch((err) => {
          dispatch(alertActions.error("An Error Occured"));
        })
    );
  };
}

function verifyUserOTP(payload) {
  return (dispatch) => {
    userServices.verifyUserOTP(payload).then(
      (user) => {
        dispatch(alertActions.success(user));
        dispatch({ type: userConstants.VERIFY });
      },
      (error) => {
        dispatch(verifyUserFailure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function verifyUserFailure(error) {
    return { type: userConstants.REQUEST_FAILURE, error };
  }
}

function forgotPassword(payload) {
  let type = payload.type;

  return (dispatch) => {
    userServices.forgotPassword(payload).then(
      (user) => {
        dispatch(alertActions.success(user?.message));
        if (type) {
          localStorage.setItem("verification-type", type);
        }
      },
      (error) => {
        dispatch(forgotPasswordFailure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function forgotPasswordFailure(error) {
    return { type: userConstants.REQUEST_FAILURE, error };
  }
}

function resetPassword(payload) { }

function changePassword(payload) {
  return (dispatch) => {
    userServices.changePassword(payload).then(
      (response) => {
        dispatch({ type: userConstants.CHANGE_PASSWORD_SUCCESS });
        dispatch(alertActions.success(response?.message || "Password changed successfully."));
      },
      (error) => {
        dispatch({ type: userConstants.REQUEST_FAILURE, error });
        dispatch(alertActions.error(error));
      }
    );
  };
}

function getAllProducts(extraParams) {
  const isLoggedIn = store.getState()?.authentication?.loggedIn;
  const queryString = extraParams ? `?${extraParams}` : '';
  return (dispatch) => {
    trackPromise(
      axios
        .get(`${API_BASE_URL}/products_listings${queryString}`)
        .then((resp) => {
          dispatch(getAllProductsSuccess(resp.data));
        })
        .then(() => {
          if (isLoggedIn) {
            axios.get(`${API_BASE_URL}/products/wishlist`).then((res) => {
              if (res.data.status) {
                dispatch({
                  type: userConstants.GET_WISHLISTS,
                  payload: res.data,
                });
              }
            });
          }
        })
        .catch((err) => { console.error('Failed to fetch:', err) })
    );
  };

  function getAllProductsSuccess(products) {
    return { type: userConstants.GET_ALL_PRODUCTS_SUCCESS, products };
  }
}

function getSingleProducts(slug) {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/single_product/?slug=${slug}`).then((resp) => {
        let data = resp.data;
        dispatch({
          type: userConstants.GET_PRODUCT_DESCRIPTION,
          payload: data,
        });
      })
    );
  };
}

function addToCart(payload) {
  const { cart_token, amount, variant, product_id } = payload;
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/orders/cart/add_to_cart`, {
        cart_token,
        variant,
        quantity: amount,
        product_id,
      })
      .then((res) => {
        if (res.data.status) {
          dispatch(addToCartRequest());
          dispatch(alertActions.success("Item Added to cart successfully"));
          // Refresh cart details so UI reflects the new item
          dispatch(getCartDetails(cart_token));
        } else {
          dispatch(alertActions.error(res.data.message));
        }
      });
  };

  function addToCartRequest(cartItems) {
    return { type: userConstants.ADD_TO_CART, cartItems };
  }
}

function updateCart(payload) {
  const { quantity, cart_item, cart_token, action } = payload;
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/orders/cart/view_cart/${cart_token}`, {
        quantity,
        cart_item,
        action,
      })
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          // Refresh cart details so UI reflects the update
          dispatch(getCartDetails(cart_token));
        } else {
          throw res.data.message || res.data.error;
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

function removeFromCart(id) {
  return (dispatch, getState) => {
    axios
      .delete(`${API_BASE_URL}/orders/cart/remove_from_cart/${id}`)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          // Refresh cart after removing item
          const cartToken = getState()?.authentication?.user?.cart_token;
          if (cartToken) {
            dispatch(getCartDetails(cartToken));
          }
        }
      });
  };
}

function getCartDetails(token) {
  return (dispatch) => {
    axios.get(`${API_BASE_URL}/orders/cart/view_cart/${token}`).then((res) => {
      dispatch(getCartItem(res.data?.cart));
    });
    function getCartItem(cartItems) {
      return { type: userConstants.GET_CART_ITEMS, cartItems };
    }
  };
}

function getOrderItem(filters = {}) {
  return (dispatch) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, val]) => {
      if (val !== undefined && val !== null && val !== "") {
        params.set(key, val);
      }
    });
    const queryString = params.toString();
    const url = `${API_BASE_URL}/orders/get_orders${queryString ? "?" + queryString : ""}`;
    trackPromise(
      axios.get(url).then((res) => {
        dispatch(orderItem(res.data.order_items, res.data.pagination));
      })
    );
  };

  function orderItem(payload, pagination) {
    return { type: userConstants.GET_ORDER_ITEMS, payload, pagination };
  }
}

function setAddress(payload) {
  return (dispatch) => {
    trackPromise(
      axios.post(`${API_BASE_URL}/user/set_addresses`, payload).then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Address saved"));
          // Refresh the address list after adding
          dispatch(getAddress());
        } else {
          dispatch(alertActions.error("All Fields are important"));
        }
      })
    );
  };
}

function getAddress() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/user/set_addresses`).then((res) => {
        dispatch({
          type: userConstants.GET_ADDRESS,
          address: res.data.addresses,
        });
      })
    );
  };
}

function getEditAddress(id) {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/user/get_edit_addresses/${id}`).then((res) => {
        if (res.data.status) {
        } else {
          dispatch(alertActions.error("Sorry! address changes failed"));
        }
      })
    );
  };
}

function editAddress(id, payload) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/user/get_edit_addresses/${id}`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Address changed successfully"));
          // Refresh the address list after editing
          dispatch(getAddress());
        } else if (!res.data.status || res.data.status === "error") {
          dispatch(alertActions.error("Sorry! address changes failed"));
        }
      });
  };
}

function deleteAddress(id) {
  return (dispatch) => {
    axios
      .delete(`${API_BASE_URL}/user/get_edit_addresses/${id}`)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          // Refresh the address list after deleting
          dispatch(getAddress());
        } else {
          if (res.data.message) {
            dispatch(alertActions.error(res.data.message));
          } else {
            dispatch(alertActions.error("Sorry! delete address failed"));
          }
        }
      });
  };
}

function setDefaultAddress(id) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/user/addresses/${id}/set-default`)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Default address updated"));
          dispatch({
            type: userConstants.SET_DEFAULT_ADDRESS,
            address: res.data.addresses,
          });
          // Also refresh addresses list and user profile
          dispatch(getAddress());
          dispatch(getUserProfile());
        } else {
          dispatch(alertActions.error("Failed to set default address"));
        }
      });
  };
}

function checkOut(payload) {
  return (dispatch) => {
    axios.post(`${API_BASE_URL}/orders/cart/checkout`, payload).then((response) => {
      if (!response.data.status) {
        dispatch(alertActions.error(response.data.message));
      } else {
        dispatch(alertActions.success(response.data.message));
        return response.data;
      }
    });
  };
}

function validateCoupon(payload) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/orders/validate-coupon/`, payload)
      .then((response) => {
        if (response.data.status) {
          dispatch({
            type: userConstants.COUPON_APPLIED,
            coupon: response.data.coupon,
          });
          dispatch(alertActions.success(response.data.message));
          return response.data;
        } else {
          dispatch({ type: userConstants.COUPON_REMOVED });
          dispatch(alertActions.error(response.data.message));
          return response.data;
        }
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message || "Invalid coupon code.";
        dispatch({ type: userConstants.COUPON_REMOVED });
        dispatch(alertActions.error(msg));
      });
  };
}

function getProductData(id) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/dashboard/products_form/metadata`)
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        if (id) {
          axios
            .get(`${API_BASE_URL}/dashboard/get_option_value/${id}`)
            .then((res) => {
              dispatch({
                type: userConstants.GET_PRODUCT_DATA,
                data,
                option_value: res.data.option_values,
              });
            });
        } else {
          dispatch({
            type: userConstants.GET_PRODUCT_DATA,
            data,
          });
        }
      });
  };
}

function searchQuery(queryParams) {
  return (dispatch) => {
    localStorage.setItem("query", queryParams);
    let data = localStorage.getItem("query");
    trackPromise(
      axios.get(`${API_BASE_URL}/products/search?q=${data}`).then((res) => {
        dispatch({
          type: userConstants.SEARCH_QUERY_PARAMS,
          searchFilter: res.data,
        });
      })
    );
  };
}

//Seller

function getSellerDashboard(filter, orderFilters = {}) {
  let { item, duration } = filter;
  return (dispatch) => {
    const params = new URLSearchParams();
    params.set("filter", item);
    params.set("duration", duration);
    Object.entries(orderFilters).forEach(([key, val]) => {
      if (val !== undefined && val !== null && val !== "") {
        params.set(key, val);
      }
    });
    trackPromise(
      axios
        .get(
          `${API_BASE_URL}/dashboard/sales_dashboard/statistics?${params.toString()}`
        )
        .then((res) => {
          dispatch({
            type: userConstants.GET_SELLER_DASHBOARD_ITEM,
            payload: res.data,
          });
        })
    );
  };
}

function getSellerOrders() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/dashboard/seller/orders`).then((res) => {
        dispatch({ type: userConstants.GET_SELLER_ORDERS, payload: res.data });
      })
    );
  };
}

function sellerOrderSearch(searchParams) {
  return (dispatch) => {
    if (searchParams.length === 1) {
      trackPromise(
        axios
          .get(
            `${API_BASE_URL}/dashboard/search_orders?search_string=${searchParams}`
          )
          .then((res) => {
            dispatch({
              type: userConstants.FILTER_SELLER_ORDERS,
              payload: res.data.orders,
            });
          })
      );
    }
  };
}

function processOrder(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/dashboard/orders/process_order`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Order was processed successfully"));
        } else {
          throw res?.data?.context.message || res.data.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

function setOrderStatus(id, payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/dashboard/orders/set_status/${id}`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch({ type: "ORDER_STATUS_CHANGED" });
          dispatch(alertActions.success(res.data.context.message));
        } else {
          throw res?.data?.context?.message;
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err));
      });
  };
}

function productListing() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/dashboard/seller_listings`).then((res) => {
        dispatch({
          type: userConstants.PRODUCTS_LISTING,
          products: res.data.products,
        });
      })
    );
  };
}

function sellerRegistration(payload) {

  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/account/sellercentre_business_info`, payload,
      )
      .then((res) => {
        if (res.data?.status) {
          dispatch(alertActions.success(res.data.message));
        } else if (res.data?.status === false) {
          throw res.data.message;
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err));
      });
  };
}

function listChatableUser() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/chats/users/`).then((res) => {
        dispatch({ type: userConstants.LIST_OF_MY_CHATS, users: res.data });
      })
    );
  };
}

function searchChatUserQuery(params) {
  return (dispatch) => {
    // localStorage.setItem("query", params);
    // let data = localStorage.getItem("query");
    trackPromise(
      axios
        .get(`${API_BASE_URL}/chats/users/search/?q=${params}`)
        .then((res) => {
          dispatch({
            type: userConstants.SEARCH_QUERY_PARAMS,
            searchFilter: res.data,
          });
        })
    );
  };
}

function getChat(sender, reciver) {
  return (dispatch) => {
    trackPromise(
      axios
        .get(
          `${API_BASE_URL}/chats/get_chat_id/?sender=${sender}&recepient=${reciver}/`
        )
        .then((res) => {
          let resp;
          let data = res.data;
          resp = {
            chat_id: data?.chat_id?.id ? data?.chat_id?.id : create_UUID(),
            sender: sender,
            recepient: reciver,
          };
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_MY_MESSAGE,
              message: resp,
            });
            return;
          }
        })
    );
  };
}

function sendChat(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/chats/messages/conversation/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.SEND_MY_MESSAGE,
            message: res.data,
          });
        }
      });
  };
}

function createCampaign(payload) {
  return (dispatch) => {
    axios
      .post(`${WS_BASE_URI}/adsmarketing`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
        } else {
          throw res.data.message || res?.data?.message.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

function getCampaign(id) {
  return (dispatch) => {
    trackPromise(
      plainAxios.get(`${WS_BASE_URI}/adsmarketing?uid=${id}`).then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_SELLER_MARKET_CAMPAIGN,
            payload: res.data.data,
          });
        }
      })
    );
  };
}

function getNewArrival() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/products/newarrivals`).then((res) => {
        dispatch({
          type: userConstants.NEW_ARRIVAL_PRODUCTS,
          products: res.data.products,
        });
      })
      .catch((err) => { console.error('Failed to fetch:', err) })
    );
  };
}

function campaignActions(actionType, campaignID) {
  return (dispatch) => {
    trackPromise(
      plainAxios
        .get(
          `${WS_BASE_URI}/adsmarketing/actions?id=${campaignID}&action=${actionType}`
        )
        .then((res) => {
          if (res.data.status) {
            dispatch(alertActions.success(`Item ${actionType}ed successfully`));
          }
        })
    );
  };
}

function getAdvert() {
  return (dispatch) => {
    trackPromise(
      plainAxios.get(`${WS_BASE_URI}/adsmarketing/feeder`).then((res) => {
        dispatch({
          type: userConstants.GET_ADVERT,
          advert: res.data?.ads,
        });
      })
    );
  };
}

function clickedAdvert(id) {
  return (dispatch) => {
    trackPromise(
      plainAxios
        .get(`${WS_BASE_URI}/adsmarketing/clicks?id=${id}`)
        .then((res) => {})
    );
  };
}

function getWishList() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/products/wishlist`).then((res) => {
        if (res.data.status) {
          dispatch({ type: userConstants.GET_WISHLISTS, payload: res.data });
        }
      })
    );
  };
}

function postWishList(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/products/wishlist`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch({ type: userConstants.ADD_WISHLIST });
          dispatch(alertActions.success(res.data.message));
        } else {
          throw res.data.message;
        }
      })
      .then(() => {
        axios.get(`${API_BASE_URL}/products/wishlist`).then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_WISHLISTS,
              payload: res.data,
            });
          }
        });
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

function deleteWishList(payload) {
  return (dispatch) => {
    axios
      .delete(`${API_BASE_URL}/products/wishlist`, { data: payload })
      .then((res) => {
        if (res.data.status) {
          dispatch({ type: userConstants.REMOVE_WISHLIST });
          dispatch(alertActions.success(res.data.message));
        } else {
          throw res.data.message;
        }
      })
      .then(() => {
        axios.get(`${API_BASE_URL}/products/wishlist`).then((res) => {
          if (res.data.status) {
            dispatch({ type: userConstants.GET_WISHLISTS, payload: res.data });
          }
        });
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

function postProductReview(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/product/single_product_review/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
        } else {
          throw res.data.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

function postSellerReviewResponse(slug, reviewId, sellerResponse) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/products/${slug}/reviews/${reviewId}/respond/`, {
        seller_response: sellerResponse,
      })
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          // Refresh the product data so the response shows immediately
          dispatch(userActions.getSingleProducts({ slug }));
        } else {
          throw res.data.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

function setStarRating(count) {
  return (dispatch) => {
    dispatch({ type: userConstants.STAR_RATING, count });
  };
}

function trackOrder(trackingNumber) {
  return (dispatch) => {
    trackPromise(
      axios
        .get(
          `${API_BASE_URL}/ordertracking/track/?tracking_number=${trackingNumber}`
        )
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.TRACK_ORDER,
              payload: res.data.data,
            });
          } else {
            throw res.data.message;
          }
        })
        .catch((e) => {
          dispatch(alertActions.error(e));
        })
    );
  };
}

function ratedProduct(product) {
  return (dispatch) => {
    dispatch({
      type: "GET_RATED_PRODUCT",
      product,
    });
  };
}

function getBuyerTransactions() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/user/get_transactions`).then((res) => {
        dispatch({
          type: userConstants.GET_BUYER_TRANSACTIONS,
          transactions: res.data.transactions,
        });
      })
    );
  };
}

function getRefund() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/user/get_transaction/refunds`).then((res) => {})
    );
  };
}

function recentlyViewed() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/products/recently_viewed`).then((res) => {
        dispatch({
          type: userConstants.GET_RECENTLY_VIEWED_PRODUCT,
          products: res.data.products,
        });
      })
    );
  };
}

function contactSeller(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/user/contact_seller/request_quote`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(
            alertActions.success("Your quote was successfully submitted")
          );
        } else {
          throw res.data.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.err(e));
      });
  };
}

function reportSeller(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/user/report_seller`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(
            alertActions.success("Your report was successfully submitted")
          );
        } else {
          throw res.data.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.err(e));
      });
  };
}

function getInbox() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/notification/inbox`).then((res) => {
        dispatch({
          type: userConstants.GET_USER_INBOX,
          inboxes: res.data.data,
        });
      })
    );
  };
}

function getProduct(product) {
  return (dispatch) => {
    dispatch({
      type: userConstants.GET_PRODUCT,
      data: product,
    });
  };
}

function getCategory(slug) {
  return (dispatch) => {
    trackPromise(
      axios
        .get(`${API_BASE_URL}/products/category_search?q=${slug}`)
        .then((res) => {
          dispatch({
            type: userConstants.GET_CATEGORY,
            category: res.data.products,
          });
        })
    );
  };
}

function getCategoryDetail(slug) {
  return (dispatch) => {
    trackPromise(
      axios
        .get(`${API_BASE_URL}/products/category_detail?q=${slug}`)
        .then((res) => {
          dispatch({
            type: userConstants.GET_CATEGORY_DETAIL,
            payload: res.data,
          });
        })
        .catch(() => {
          dispatch({
            type: userConstants.GET_CATEGORY_DETAIL,
            payload: null,
          });
        })
    );
  };
}

function editProduct(payload, slug) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/dashboard/new_product?slug=${slug}`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(`Products edited successfully`));
        } else {
          dispatch(
            alertActions.error("Editing of  Product was not successful")
          );
        }
      });
  };
}

function getAllJobs() {
  return (dispatch) => {
    trackPromise(
      plainAxios.get(`${WS_BASE_URI}/careers/alljobs/`).then((res) => {
        dispatch({
          type: userConstants.GET_ALL_JOBS,
          jobs: res.data.jobs,
        });
      })
    );
  };
}

function applyForJob(payload) {
  return (dispatch) => {
    axios
      .post(`${WS_BASE_URI}/careers/jobs/application/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
        } else {
          throw res.data.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

function getJobPostings() {
  return (dispatch) => {
    trackPromise(
      plainAxios.get(`${WS_BASE_URI}/careers/postings/`).then((res) => {
        dispatch({
          type: userConstants.GET_JOB_POSTINGS,
          jobPostings: res.data.jobs,
        });
      })
    );
  };
}

function getJobPostingDetail(id) {
  return (dispatch) => {
    trackPromise(
      plainAxios.get(`${WS_BASE_URI}/careers/postings/${id}/`).then((res) => {
        dispatch({
          type: userConstants.GET_JOB_POSTING_DETAIL,
          jobPostingDetail: res.data.job,
        });
      })
    );
  };
}

function submitJobApplication(id, formData) {
  return (dispatch) => {
    axios
      .post(`${WS_BASE_URI}/careers/postings/${id}/apply/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.SUBMIT_JOB_APPLICATION,
          });
        } else {
          throw res.data.message || "Application failed";
        }
      })
      .catch((e) => {
        const msg = typeof e === "string" ? e : e?.response?.data?.errors || "Application failed";
        dispatch(alertActions.error(msg));
      });
  };
}

function getAllUsers() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/users/all/`).then((res) => {
        dispatch({
          type: userConstants.GET_ALL_USERS,
          users: res.data,
        });
      })
    );
  };
}

function getNDA() {
  return (dispatch) => {
    trackPromise(
      axios
        .get(`${API_BASE_URL}/nda/`)
        .then((res) => {
          dispatch({
            type: userConstants.GET_NDA,
            NDA: res.data.nda_list,
          });
        })
        .catch((err) => {
          dispatch(alertActions.error(err.message || err));
        })
    );
  };
}

function getNDAPrice() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/get_nda/pricelist`).then((res) => {
        dispatch({
          type: userConstants.GET_NDA_PRICE_LIST,
          NDA_price_list: res.data.nda_price_list,
        });
      })
    );
  };
}

function getNDAPackages() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/nda/packages/list`).then((res) => {
        dispatch({
          type: userConstants.GET_NDA_PACKAGES_LIST,
          NDA_packages_list: res.data,
        });
      })
    );
  };
}

function purchaseNDA(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/nda/register_purchase`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.message || err));
      });
  };
}

function sendNDA(payload, action) {
  return (dispatch) => {
    if (action !== "send") {
      axios
        .post(`${API_BASE_URL}/nda`, payload)
        .then((res) => {
          if (res.data.status) {
            dispatch(alertActions.success(res.data.message));
          }
        })
        .catch((err) => {
          dispatch(alertActions.error(err.message || err));
        });
    } else {
      axios
        .post(`${API_BASE_URL}/nda/`, payload)
        .then((res) => {
          if (res.data.status) {
            dispatch(alertActions.success(res.data.message));
          } else if (!res.data.status) {
            throw res.data.message;
          }
        })
        .catch((err) => {
          dispatch(alertActions.error(err));
        });
    }
  };
}

function getPurchasedNDA() {
  return (dispatch) => {
    axios.get(`${API_BASE_URL}/nda/register_purchase`).then((res) => {
      if (res.data.status) {
        dispatch({
          type: userConstants.GET_PURCHASED_NDA,
          nda: res.data.nda_count,
        });
      }
    });
  };
}

function getNDAProposal() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/nda/proposals/`).then((res) => {
        dispatch({
          type: userConstants.GET_MY_NDAPROPOSAL,
          proposals: res.data,
        });
      })
    );
  };
}

function handleNDA(payload) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/nda/proposals/`, payload)
      .then((res) => {
        dispatch(alertActions.success(res.data.message));
      })
      .catch((e) => {
        dispatch(alertActions.error(e.message || e.errors || e));
      });
  };
}

function getCampaignReg(payload, type, selection) {
  let id;
  if (selection === "bulk") {
    for (let i = 0; i < payload.length; i++) {
      id = payload[i].product_id;
    }
  }
  return (dispatch) => {
    dispatch({
      type: type,
      data: payload,
      selection,
      id,
    });
  };
}

function currencyConverter({ toCurrency, amount }) {
  return (dispatch) => {
    // If converting to USD (base currency), skip the API call
    if (toCurrency === "USD") {
      dispatch({
        type: userConstants.CONVERT_CURRENCY,
        payload: {
          currency: "USD",
          amount: amount,
        },
      });
      return;
    }

    const apiKey = process.env.REACT_APP_RAPIDAPI_KEY;
    if (!apiKey) {
      console.error(
        "REACT_APP_RAPIDAPI_KEY is not set. Currency conversion unavailable."
      );
      dispatch({
        type: userConstants.CONVERT_CURRENCY,
        payload: {
          currency: toCurrency,
          amount: amount, // fallback: 1:1 rate
        },
      });
      return;
    }

    axios
      .get("https://currency-converter5.p.rapidapi.com/currency/convert", {
        params: { format: "json", from: "USD", to: toCurrency, amount },
        headers: {
          "X-RapidAPI-Key": apiKey,
          "X-RapidAPI-Host": "currency-converter5.p.rapidapi.com",
        },
      })
      .then((res) => {
        const rateForAmount =
          Object.values(res.data.rates)[0]?.rate_for_amount;
        dispatch({
          type: userConstants.CONVERT_CURRENCY,
          payload: {
            currency: toCurrency,
            amount: Math.ceil(rateForAmount),
          },
        });
      })
      .catch(function (error) {
        console.error("Currency conversion failed:", error);
        // Fallback: keep selected currency but use 1:1 rate
        dispatch({
          type: userConstants.CONVERT_CURRENCY,
          payload: {
            currency: toCurrency,
            amount: amount,
          },
        });
      });
  };
}

function updateUserTimezone({ id, timezone }) {
  return (dispatch) => {
    axios.get(`/chats/update_tz/?id=${id}&tz=${timezone}`).then((res) => { });
  };
}

function getUserTimezone(id) {
  return (dispatch) => {
    axios.get(`chats/get_user_tz/?id=${id}`).then((res) => {
      localStorage.setItem("local-time", res.data.localTime);
    });
  };
}

// Country Detection via IP

function detectCountry() {
  return (dispatch) => {
    // Check localStorage cache first to avoid repeated API calls
    const cached = localStorage.getItem("detected-country");
    if (cached) {
      try {
        const data = JSON.parse(cached);
        dispatch({
          type: userConstants.SET_DETECTED_COUNTRY,
          payload: data,
        });
        return;
      } catch (e) {
        localStorage.removeItem("detected-country");
      }
    }

    // Use ipapi.co (same API already used in MobileHeader)
    import("axios").then(({ default: rawAxios }) => {
      rawAxios
        .get("https://ipapi.co/json/")
        .then((response) => {
          const d = response.data;
          const payload = {
            ip: d.ip,
            countryName: d.country_name,
            countryCode: d.country_code,
            city: d.city,
            timezone: d.timezone,
          };
          localStorage.setItem("detected-country", JSON.stringify(payload));
          dispatch({
            type: userConstants.SET_DETECTED_COUNTRY,
            payload,
          });
        })
        .catch((error) => {
          console.error("Country detection failed:", error);
        });
    });
  };
}

function saveDetectedCountryToProfile() {
  return (dispatch, getState) => {
    const state = getState();
    const geo = state.geoLocation;
    const token = state.authentication?.user?.jwt_token;
    if (!geo.detected || !token) return;

    axios
      .post(`${API_BASE_URL}/user/save-detected-country/`, {
        country_name: geo.countryName,
        country_code: geo.countryCode,
        city: geo.city,
        timezone: geo.timezone,
      })
      .then(() => {
        // Saved silently
      })
      .catch((err) => {
        console.error("Failed to save detected country to profile:", err);
      });
  };
}

// Sponsorship Page

function addSponsorShipProduct(payload) {
  return (dispatch) => {
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    }
    axios
      .post(
        `${WS_BASE_URI}/account_sponsorship/sponsorship_product_test/`, payload, config
      )
      .then((res) => {
        if (res.status) {
          dispatch(alertActions.success(`Products added successfully`));
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.message || err));
      });
  };
}

function getAllSponsorshipProducts() {
  return (dispatch) => {
    axios
      .get(`${WS_BASE_URI}/account_sponsorship/get_sponsorship/`)
      .then((resp) => {
        dispatch(getAllSponsorshipProductsSuccess(resp?.data?.product));
      }).catch((err) => {
        dispatch(alertActions.error(err.message || err));
      })
  };

  function getAllSponsorshipProductsSuccess(products) {
    return {
      type: userConstants.GET_ALL_SPONSORSHIP_PRODUCT_SUCCESS,
      products,
    };
  }
}

function fundProduct(payload) {
  return (dispatch) => {
    axios
      .post(`${WS_BASE_URI}/account_sponsorship/sponsorship_product/fund`, payload)
      .then((res) => {
          dispatch(alertActions.success(res.data.message || `Funding successfully`));
      })
      .catch((err) => {
        dispatch(alertActions.error(err.message || err));
      });
  };
}


function removeData(removeData) {
  return (dispatch) => {
    dispatch({
      type: userConstants.REMOVEDATA,
      removeData
    });
  };
}

function getSellerVerification() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/seller/verification/status/`)
      .then((res) => {
        if (res.data?.status) {
          dispatch({
            type: userConstants.GET_SELLER_VERIFICATION,
            payload: res.data.data,
          });
        }
      })
      .catch((err) => {
        console.error("getSellerVerification error:", err);
      });
  };
}

function submitSellerVerification(formData) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/seller/verification/submit-doc/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data?.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.SUBMIT_SELLER_VERIFICATION,
            payload: res.data.data,
          });
        } else {
          dispatch(alertActions.error(res.data.message || "Submission failed."));
        }
        return res.data;
      })
      .catch((err) => {
        dispatch(alertActions.error(err?.response?.data?.message || err.message || "Submission failed."));
        throw err;
      });
  };
}

function getFilterOptions(categorySlug) {
  const url = categorySlug
    ? `${API_BASE_URL}/products/filter-options/?category=${categorySlug}`
    : `${API_BASE_URL}/products/filter-options/`;
  return (dispatch) => {
    trackPromise(
      axios.get(url).then((res) => {
        dispatch({
          type: userConstants.GET_FILTER_OPTIONS,
          payload: res.data,
        });
      })
    );
  };
}

// Campaign Updates

function getCampaignUpdates(campaignId) {
  return (dispatch) => {
    trackPromise(
      plainAxios
        .get(`${WS_BASE_URI}/account_sponsorship/updates/${campaignId}/`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_CAMPAIGN_UPDATES,
              updates: res.data.updates,
            });
          }
        })
        .catch((err) => {
          console.error("getCampaignUpdates error:", err);
        })
    );
  };
}

function createCampaignUpdate(payload) {
  return (dispatch) => {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };
    axios
      .post(`${WS_BASE_URI}/account_sponsorship/updates/`, payload, config)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Update posted successfully"));
          dispatch({
            type: userConstants.CREATE_CAMPAIGN_UPDATE,
            update: res.data.update,
          });
        } else {
          throw res.data.message || "Failed to post update";
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.message || err));
      });
  };
}

function getSponsorshipProductDetail(uid) {
  return (dispatch) => {
    trackPromise(
      plainAxios
        .get(`${WS_BASE_URI}/account_sponsorship/sponsorship_product/${uid}`)
        .then((resp) => {
          dispatch({
            type: userConstants.GET_SPONSORSHIP_PRODUCT_DETAIL,
            product: resp?.data?.product,
          });
        })
        .catch((err) => {
          dispatch(alertActions.error(err.message || err));
        })
    );
  };
}

function getCampaignRewards(campaignId) {
  return (dispatch) => {
    trackPromise(
      plainAxios
        .get(`${WS_BASE_URI}/account_sponsorship/rewards/${campaignId}/`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_CAMPAIGN_REWARDS,
              rewards: res.data.rewards,
            });
          }
        })
        .catch((err) => {
          console.error("getCampaignRewards error:", err);
        })
    );
  };
}

function getSellerBoostStatus() {
  return (dispatch) => {
    trackPromise(
      axios
        .get(`${API_BASE_URL}/products/boost/`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_SELLER_BOOST_STATUS,
              products: res.data.products,
            });
          }
        })
        .catch((err) => {
          console.error("getSellerBoostStatus error:", err);
        })
    );
  };
}

function boostProduct(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/products/boost/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.BOOST_PRODUCT_SUCCESS,
            payload: res.data,
          });
          // Refresh boost status
          dispatch(getSellerBoostStatus());
        } else {
          throw res.data.message;
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.message || err));
      });
  };
}

function getBoostAnalytics() {
  return (dispatch) => {
    trackPromise(
      axios
        .get(`${API_BASE_URL}/dashboard/seller/boost-analytics`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_BOOST_ANALYTICS,
              analytics: res.data.analytics,
            });
          }
        })
        .catch((err) => {
          console.error("getBoostAnalytics error:", err);
        })
    );
  };
}

// Buyer Dashboard Stats
function getBuyerDashboardStats() {
  return (dispatch) => {
    dispatch({ type: "BUYER_DASHBOARD_STATS_LOADING" });
    trackPromise(
      axios
        .get(`${API_BASE_URL}/buyer/dashboard-stats/`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_BUYER_DASHBOARD_STATS,
              payload: res.data.data,
            });
          } else {
            throw res.data.message || "Failed to load dashboard stats";
          }
        })
        .catch((err) => {
          dispatch({
            type: userConstants.GET_BUYER_DASHBOARD_STATS_FAILURE,
            error: err.message || err,
          });
        })
    );
  };
}

// Seller Dashboard Stats
function getSellerDashboardStats() {
  return (dispatch) => {
    trackPromise(
      axios
        .get(`${API_BASE_URL}/dashboard/seller/dashboard-stats`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_SELLER_DASHBOARD_STATS,
              payload: res.data,
            });
          }
        })
        .catch((err) => {
          console.error("getSellerDashboardStats error:", err);
        })
    );
  };
}

// Seller Product Views (Top Viewed Products)
function getSellerProductViews() {
  return (dispatch) => {
    trackPromise(
      axios
        .get(`${API_BASE_URL}/dashboard/seller/product-views`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_SELLER_PRODUCT_VIEWS,
              payload: res.data.top_viewed_products,
            });
          } else {
            throw res.data.message || "Failed to load product views";
          }
        })
        .catch((err) => {
          dispatch({
            type: userConstants.GET_SELLER_PRODUCT_VIEWS_FAILURE,
            error: err.message || err,
          });
          console.error("getSellerProductViews error:", err);
        })
    );
  };
}

// Seller Performance
function getSellerPerformance(startDate, endDate) {
  return (dispatch) => {
    let url = `${API_BASE_URL}/dashboard/seller/performance`;
    if (startDate && endDate) {
      url += `?start_date=${startDate}&end_date=${endDate}`;
    }
    trackPromise(
      axios
        .get(url)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_SELLER_PERFORMANCE,
              payload: res.data,
            });
          }
        })
        .catch((err) => {
          console.error("getSellerPerformance error:", err);
        })
    );
  };
}

// Revenue Share Negotiation

function getRevenueShareOffer(campaignId) {
  return (dispatch) => {
    trackPromise(
      plainAxios
        .get(`${WS_BASE_URI}/account_sponsorship/revenue-share/${campaignId}/`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_REVENUE_SHARE_OFFER,
              offer: res.data.offer,
            });
          }
        })
        .catch((err) => {
          console.error("getRevenueShareOffer error:", err);
        })
    );
  };
}

function createRevenueShareOffer(payload) {
  return (dispatch) => {
    axios
      .post(`${WS_BASE_URI}/account_sponsorship/revenue-share/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Revenue share offer submitted successfully."));
          dispatch({
            type: userConstants.CREATE_REVENUE_SHARE_OFFER,
            offer: res.data.offer,
          });
        } else {
          throw res.data.message || "Failed to submit offer";
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function revenueShareAction(offerId, payload) {
  return (dispatch) => {
    axios
      .put(`${WS_BASE_URI}/account_sponsorship/revenue-share/action/${offerId}/`, payload)
      .then((res) => {
        if (res.data.status) {
          const actionLabel =
            payload.action === "accept" ? "accepted" :
            payload.action === "decline" ? "declined" : "counter submitted";
          dispatch(alertActions.success(`Revenue share offer ${actionLabel}.`));
          dispatch({
            type: userConstants.UPDATE_REVENUE_SHARE_OFFER,
            offer: res.data.offer,
          });
        } else {
          throw res.data.message || "Action failed";
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

// ─── Quote Request Actions ────────────────────────────────────────────────

function submitQuoteRequest(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/quotes/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.SUBMIT_QUOTE_REQUEST,
            quote: res.data.quote,
          });
        } else {
          throw res.data.message || "Failed to submit quote request";
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function getBuyerQuotes() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/quotes/buyer/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_BUYER_QUOTES,
            quotes: res.data.quotes,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function getSellerQuotes() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/quotes/seller/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_SELLER_QUOTES,
            quotes: res.data.quotes,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function respondToQuote(quoteId, payload) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/quotes/${quoteId}/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.RESPOND_TO_QUOTE,
            quote: res.data.quote,
          });
        } else {
          throw res.data.message || "Action failed";
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

// Seller Onboarding Status
function getSellerOnboardingStatus() {
  return (dispatch) => {
    dispatch({ type: "GET_SELLER_ONBOARDING_STATUS_REQUEST" });
    trackPromise(
      axios
        .get(`${API_BASE_URL}/dashboard/seller/onboarding-status`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: "GET_SELLER_ONBOARDING_STATUS",
              payload: res.data,
            });
          }
        })
        .catch((err) => {
          console.error("getSellerOnboardingStatus error:", err);
          dispatch({ type: "GET_SELLER_ONBOARDING_STATUS_FAILURE" });
        })
    );
  };
}

function dismissSellerOnboarding() {
  return (dispatch) => {
    dispatch({ type: "DISMISS_SELLER_ONBOARDING" });
  };
}

function completeSellerOnboarding() {
  return (dispatch) => {
    trackPromise(
      axios
        .post(`${API_BASE_URL}/dashboard/seller/onboarding-complete`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: "SELLER_ONBOARDING_COMPLETE",
              payload: res.data,
            });
          }
        })
        .catch((err) => {
          console.error("completeSellerOnboarding error:", err);
        })
    );
  };
}

// Featured Sellers (public, no auth)
function getFeaturedSellers() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/featured-sellers/`)
      .then((res) => {
        dispatch({
          type: userConstants.GET_FEATURED_SELLERS,
          sellers: res.data.sellers,
        });
      })
      .catch((err) => {
        console.error("getFeaturedSellers error:", err);
      });
  };
}

function fetchProductQuestions(slug) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/products/${slug}/questions/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_PRODUCT_QUESTIONS,
            payload: res.data.questions,
          });
        }
      })
      .catch((e) => {
        console.error("fetchProductQuestions error:", e);
      });
  };
}

function postProductQuestion(slug, questionText) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/products/${slug}/questions/`, {
        question: questionText,
      })
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          // Refresh questions list
          dispatch(userActions.fetchProductQuestions(slug));
        } else {
          throw res.data.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

function answerProductQuestion(slug, questionId, answerText) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/products/${slug}/questions/${questionId}/answer/`, {
        answer: answerText,
      })
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          // Refresh questions list
          dispatch(userActions.fetchProductQuestions(slug));
        } else {
          throw res.data.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e));
      });
  };
}

// Seller Vacation Mode
function getSellerVacation() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/seller/vacation/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_SELLER_VACATION,
            payload: res.data.data,
          });
        }
      })
      .catch((err) => {
        console.error("getSellerVacation error:", err);
      });
  };
}

function updateSellerVacation(payload) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/seller/vacation/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.UPDATE_SELLER_VACATION,
            payload: res.data.data,
          });
          dispatch(alertActions.success(res.data.message));
        } else {
          dispatch(alertActions.error(res.data.message));
        }
      })
      .catch((err) => {
        dispatch(alertActions.error("Failed to update vacation mode."));
        console.error("updateSellerVacation error:", err);
      });
  };
}

function getCampaignRating(campaignId) {
  return (dispatch) => {
    axios
      .get(`${WS_BASE_URI}/account_sponsorship/rating/${campaignId}/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_CAMPAIGN_RATING,
            rating: res.data.rating,
            reasoning: res.data.reasoning,
            rated_at: res.data.rated_at,
          });
        }
      })
      .catch((err) => {
        console.error("getCampaignRating error:", err);
      });
  };
}

function getCampaignExtensionStatus(campaignId) {
  return (dispatch) => {
    axios
      .get(`${WS_BASE_URI}/account_sponsorship/extend/${campaignId}/status/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_CAMPAIGN_EXTENSION_STATUS,
            extensionData: res.data,
          });
        }
      })
      .catch((err) => {
        console.error("getCampaignExtensionStatus error:", err);
      });
  };
}

function requestCampaignExtension(payload) {
  const config = {
    headers: { "Content-Type": "application/json" },
  };
  return (dispatch) => {
    return axios
      .post(`${WS_BASE_URI}/account_sponsorship/extend/`, payload, config)
      .then((res) => {
        dispatch({
          type: userConstants.REQUEST_CAMPAIGN_EXTENSION,
          extensionData: res.data,
        });
        dispatch(
          alertActions.success(
            res.data.message || "Extension requested successfully."
          )
        );
        // Refresh extension status
        if (payload.campaign_id) {
          dispatch(getCampaignExtensionStatus(payload.campaign_id));
        }
        return res.data;
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          "Failed to request extension.";
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

function getSellerBundles() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/seller/bundles/`).then((resp) => {
        dispatch({
          type: userConstants.GET_SELLER_BUNDLES,
          payload: resp.data.bundles,
        });
      })
    );
  };
}

function createSellerBundle(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/seller/bundles/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Bundle created successfully"));
          dispatch(getSellerBundles());
        } else {
          dispatch(alertActions.error(res.data.message || "Failed to create bundle"));
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err?.response?.data?.message || "Failed to create bundle"));
      });
  };
}

function deleteSellerBundle(bundleId) {
  return (dispatch) => {
    axios
      .delete(`${API_BASE_URL}/seller/bundles/${bundleId}/`)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Bundle deleted"));
          dispatch(getSellerBundles());
        }
      })
      .catch((err) => {
        dispatch(alertActions.error("Failed to delete bundle"));
      });
  };
}

function addBundleToCart(products, cartToken) {
  return (dispatch) => {
    const promises = products.map((product) =>
      axios.post(`${API_BASE_URL}/orders/cart/add_to_cart`, {
        cart_token: cartToken,
        variant: product.variants?.[0]?.id || null,
        quantity: 1,
        product_id: product.id,
      })
    );
    Promise.all(promises)
      .then(() => {
        dispatch(alertActions.success("All bundle items added to cart"));
        dispatch(getCartDetails(cartToken));
      })
      .catch(() => {
        dispatch(alertActions.error("Some items could not be added to cart"));
      });
  };
}

function getWishlistShareStatus() {
  return (dispatch) => {
    axios.get(`${API_BASE_URL}/products/wishlist/share/`).then((res) => {
      if (res.data.status) {
        dispatch({
          type: userConstants.GET_WISHLIST_SHARE_STATUS,
          payload: res.data,
        });
      }
    });
  };
}

function toggleWishlistShare() {
  return (dispatch) => {
    axios.put(`${API_BASE_URL}/products/wishlist/share/`).then((res) => {
      if (res.data.status) {
        dispatch({
          type: userConstants.TOGGLE_WISHLIST_SHARE,
          payload: res.data,
        });
      }
    });
  };
}

function getSharedWishlist(token, isFolder = false) {
  return (dispatch) => {
    const url = isFolder
      ? `${API_BASE_URL}/wishlist/shared-folder/${token}/`
      : `${API_BASE_URL}/products/wishlist/shared/${token}/`;
    trackPromise(
      axios
        .get(url, {
          // No auth header needed for public endpoint
          transformRequest: [(data, headers) => {
            delete headers["Authorization"];
            return data;
          }],
        })
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_SHARED_WISHLIST,
              payload: res.data,
            });
          }
        })
        .catch(() => {
          dispatch({
            type: userConstants.GET_SHARED_WISHLIST,
            payload: { status: false, not_found: true },
          });
        })
    );
  };
}

function fetchPriceHistory(slug) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/products/${slug}/price-history/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_PRICE_HISTORY,
            payload: res.data,
          });
        }
      })
      .catch((e) => {
        console.error("fetchPriceHistory error:", e);
      });
  };
}

// ─── Saved Searches ──────────────────────────────────────────────────────────

function getSavedSearches() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/products/saved-searches/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_SAVED_SEARCHES,
            payload: res.data.saved_searches,
          });
        }
      })
      .catch((e) => {
        console.error("getSavedSearches error:", e);
      });
  };
}

function saveSearch(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/products/saved-searches/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.SAVE_SEARCH,
            payload: res.data.saved_search,
          });
          dispatch(alertActions.success(res.data.message));
        } else {
          dispatch(alertActions.error(res.data.message));
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e?.response?.data?.message || "Failed to save search."));
      });
  };
}

function deleteSavedSearch(searchId) {
  return (dispatch) => {
    axios
      .delete(`${API_BASE_URL}/products/saved-searches/${searchId}/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.DELETE_SAVED_SEARCH,
            payload: searchId,
          });
          dispatch(alertActions.success(res.data.message));
        }
      })
      .catch((e) => {
        dispatch(alertActions.error("Failed to delete saved search."));
      });
  };
}

function toggleSavedSearchNotify(searchId, notifyOnMatch) {
  return (dispatch) => {
    axios
      .patch(`${API_BASE_URL}/products/saved-searches/${searchId}/`, {
        notify_on_match: notifyOnMatch,
      })
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.TOGGLE_SAVED_SEARCH_NOTIFY,
            payload: res.data.saved_search,
          });
          dispatch(alertActions.success(res.data.message));
        }
      })
      .catch((e) => {
        dispatch(alertActions.error("Failed to update notification preference."));
      });
  };
}

function joinWaitlist(slug, variant_id, quantity_needed) {
  return (dispatch) => {
    const body = {};
    if (variant_id) body.variant_id = variant_id;
    if (quantity_needed) body.quantity_needed = quantity_needed;
    axios
      .post(`${API_BASE_URL}/products/${slug}/waitlist/`, body)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.JOIN_WAITLIST,
            payload: {
              slug,
              waitlist_count: res.data.waitlist_count,
              total_demand: res.data.total_demand,
              quantity_needed: res.data.quantity_needed,
            },
          });
          dispatch(alertActions.success(res.data.message));
        }
      })
      .catch((e) => {
        const msg =
          e?.response?.data?.message || "Failed to join waitlist.";
        dispatch(alertActions.error(msg));
      });
  };
}

function leaveWaitlist(slug, variant_id) {
  return (dispatch) => {
    const body = variant_id ? { variant_id } : {};
    axios
      .delete(`${API_BASE_URL}/products/${slug}/waitlist/`, { data: body })
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.LEAVE_WAITLIST,
            payload: { slug },
          });
          dispatch(alertActions.success(res.data.message));
        }
      })
      .catch((e) => {
        const msg =
          e?.response?.data?.message || "Failed to leave waitlist.";
        dispatch(alertActions.error(msg));
      });
  };
}

function getWaitlistStatus(slug) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/products/${slug}/waitlist/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_WAITLIST_STATUS,
            payload: res.data,
          });
        }
      })
      .catch(() => {});
  };
}

function getUserWaitlist() {
  return (dispatch) => {
    dispatch({ type: "GET_USER_WAITLIST_LOADING" });
    axios
      .get(`${API_BASE_URL}/user/waitlist/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_USER_WAITLIST,
            payload: res.data.waitlist,
          });
        }
      })
      .catch(() => {});
  };
}

function getSellerWaitlistDemand() {
  return (dispatch) => {
    dispatch({ type: "GET_SELLER_WAITLIST_DEMAND_LOADING" });
    axios
      .get(`${API_BASE_URL}/seller/waitlist-demand/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_SELLER_WAITLIST_DEMAND,
            payload: res.data.demand,
          });
        }
      })
      .catch(() => {});
  };
}

function waitlistDeposit(slug, variant_id) {
  return (dispatch) => {
    const body = variant_id ? { variant_id } : {};
    axios
      .post(`${API_BASE_URL}/products/${slug}/waitlist/deposit/`, body)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.WAITLIST_DEPOSIT,
            payload: {
              slug,
              deposit_amount: res.data.deposit_amount,
            },
          });
          dispatch(alertActions.success(res.data.message));
        }
      })
      .catch((e) => {
        const msg = e?.response?.data?.message || "Failed to place deposit.";
        dispatch(alertActions.error(msg));
      });
  };
}

function getExclusiveWindow(slug) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/products/${slug}/exclusive-window/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_EXCLUSIVE_WINDOW,
            payload: res.data,
          });
        }
      })
      .catch(() => {});
  };
}

function getBuyerLoyalty() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/user/loyalty/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_BUYER_LOYALTY,
            payload: res.data,
          });
        }
      })
      .catch(() => {});
  };
}

function getSellerGoals() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/dashboard/seller/goals`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_SELLER_GOALS,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        console.error("getSellerGoals error:", err);
      });
  };
}

function updateSellerGoals(data) {
  return (dispatch) => {
    return axios
      .put(`${API_BASE_URL}/dashboard/seller/goals`, data)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.UPDATE_SELLER_GOALS,
            payload: res.data,
          });
          // Refresh dashboard stats to get updated goal percentages
          dispatch(getSellerDashboardStats());
        }
        return res.data;
      })
      .catch((err) => {
        console.error("updateSellerGoals error:", err);
      });
  };
}

function getSellerDisputes() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/seller/disputes/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_SELLER_DISPUTES,
            disputes: res.data.disputes,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function respondToDispute(disputeId, sellerResponse, sellerEvidenceText) {
  return (dispatch) => {
    return axios
      .put(`${API_BASE_URL}/seller/disputes/${disputeId}/respond/`, {
        seller_response: sellerResponse,
        seller_evidence_text: sellerEvidenceText || "",
      })
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.RESPOND_TO_DISPUTE,
            dispute: res.data.dispute,
          });
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

// ─── Buyer Disputes ──────────────────────────────────────────────────────────

function getBuyerDisputes() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/orders/disputes/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_BUYER_DISPUTES,
            disputes: res.data.disputes,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function createBuyerDispute(data) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/orders/disputes/`, data)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.CREATE_BUYER_DISPUTE,
            dispute: res.data.dispute,
          });
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

function getDisputeDetail(disputeId) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/orders/disputes/${disputeId}/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_DISPUTE_DETAIL,
            dispute: res.data.dispute,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function uploadDisputeEvidence(disputeId, formData) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/orders/disputes/${disputeId}/evidence/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.UPLOAD_DISPUTE_EVIDENCE,
            disputeId,
            evidence: res.data.evidence,
          });
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

function appealDispute(disputeId, data) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/orders/disputes/${disputeId}/appeal/`, data)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.APPEAL_DISPUTE,
            dispute: res.data.dispute,
          });
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

// ─── Arbitration ──────────────────────────────────────────────────────────────

function requestArbitration(disputeId, requestReason) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/orders/disputes/${disputeId}/request-arbitration/`, {
        request_reason: requestReason,
      })
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.REQUEST_ARBITRATION,
            arbitration: res.data.arbitration,
          });
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

function getArbitrationStatus(disputeId) {
  return (dispatch) => {
    return axios
      .get(`${API_BASE_URL}/orders/disputes/${disputeId}/arbitration/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_ARBITRATION_STATUS,
            arbitration: res.data.arbitration,
          });
        }
        return res.data;
      })
      .catch((err) => {
        // Not an error if arbitration doesn't exist
        if (err?.response?.status !== 404) {
          const msg = err?.response?.data?.message || err.message || err;
          dispatch(alertActions.error(msg));
        }
        return { status: false };
      });
  };
}

function payArbitrationBond(arbitrationId) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/arbitration/${arbitrationId}/pay-bond/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.PAY_ARBITRATION_BOND,
            arbitration: res.data.arbitration,
            clientSecret: res.data.client_secret,
            paymentIntentId: res.data.payment_intent_id,
          });
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

function confirmArbitrationBond(arbitrationId, paymentIntentId) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/arbitration/${arbitrationId}/confirm-bond/`, {
        payment_intent_id: paymentIntentId,
      })
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.CONFIRM_ARBITRATION_BOND,
            arbitration: res.data.arbitration,
          });
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

// ─── Collections ──────────────────────────────────────────────────────────────

function getSellerCollections() {
  return (dispatch) => {
    trackPromise(
      axios.get(`${API_BASE_URL}/seller/collections/`).then((resp) => {
        dispatch({
          type: userConstants.GET_SELLER_COLLECTIONS,
          payload: resp.data.collections,
        });
      })
    );
  };
}

function createSellerCollection(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/seller/collections/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Collection created successfully"));
          dispatch(getSellerCollections());
        } else {
          dispatch(alertActions.error(res.data.message || "Failed to create collection"));
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err?.response?.data?.message || "Failed to create collection"));
      });
  };
}

function updateSellerCollection(collectionId, payload) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/seller/collections/${collectionId}/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Collection updated"));
          dispatch(getSellerCollections());
        } else {
          dispatch(alertActions.error(res.data.message || "Failed to update collection"));
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err?.response?.data?.message || "Failed to update collection"));
      });
  };
}

function deleteSellerCollection(collectionId) {
  return (dispatch) => {
    axios
      .delete(`${API_BASE_URL}/seller/collections/${collectionId}/`)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Collection deleted"));
          dispatch(getSellerCollections());
        }
      })
      .catch((err) => {
        dispatch(alertActions.error("Failed to delete collection"));
      });
  };
}

// ─── Product Certifications ─────────────────────────────────────────────────

function fetchProductCertifications(slug) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/products/${slug}/certifications/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_PRODUCT_CERTIFICATIONS,
            payload: res.data.certifications,
          });
        }
      })
      .catch((e) => {
        console.error("fetchProductCertifications error:", e);
      });
  };
}

function uploadProductCertification(slug, formData) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/products/${slug}/certifications/`, formData)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.UPLOAD_PRODUCT_CERTIFICATION,
            payload: res.data.certification,
          });
          // Refresh the full list
          dispatch(fetchProductCertifications(slug));
        } else {
          throw res.data.message;
        }
      })
      .catch((e) => {
        dispatch(alertActions.error(e?.response?.data?.message || e || "Failed to upload certification"));
      });
  };
}

// Buyer Onboarding Status
function getBuyerOnboardingStatus() {
  return (dispatch) => {
    dispatch({ type: "GET_BUYER_ONBOARDING_STATUS_REQUEST" });
    trackPromise(
      axios
        .get(`${API_BASE_URL}/dashboard/buyer/onboarding-status`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: "GET_BUYER_ONBOARDING_STATUS",
              payload: res.data,
            });
          }
        })
        .catch((err) => {
          console.error("getBuyerOnboardingStatus error:", err);
          dispatch({ type: "GET_BUYER_ONBOARDING_STATUS_FAILURE" });
        })
    );
  };
}

function dismissBuyerOnboarding() {
  return (dispatch) => {
    dispatch({ type: "DISMISS_BUYER_ONBOARDING" });
  };
}

// ── Shipping Estimate ──

function getShippingEstimate(productSlug, destination) {
  return (dispatch) => {
    dispatch({ type: "SHIPPING_ESTIMATE_LOADING" });
    return trackPromise(
      axios
        .get(`${API_BASE_URL}/shipping/estimate/?product_slug=${encodeURIComponent(productSlug)}&destination=${encodeURIComponent(destination)}`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_SHIPPING_ESTIMATE,
              payload: res.data,
            });
          } else {
            dispatch({
              type: "SHIPPING_ESTIMATE_ERROR",
              payload: res.data.message || "Failed to get shipping estimate.",
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: "SHIPPING_ESTIMATE_ERROR",
            payload: err.response?.data?.message || "Failed to get shipping estimate.",
          });
        })
    );
  };
}

function clearShippingEstimate() {
  return (dispatch) => {
    dispatch({ type: userConstants.CLEAR_SHIPPING_ESTIMATE });
  };
}

function getAdminShippingRates() {
  return (dispatch) => {
    dispatch({ type: "ADMIN_SHIPPING_RATES_LOADING" });
    return trackPromise(
      axios
        .get(`${API_BASE_URL}/admin/shipping-rates/`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_ADMIN_SHIPPING_RATES,
              payload: res.data.rates,
            });
          }
        })
        .catch((err) => {
          console.error("getAdminShippingRates error:", err);
        })
    );
  };
}

function createShippingRate(data) {
  return (dispatch) => {
    return trackPromise(
      axios
        .post(`${API_BASE_URL}/admin/shipping-rates/`, data)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.CREATE_SHIPPING_RATE,
              payload: res.data.rate,
            });
            dispatch(alertActions.success(res.data.message));
          } else {
            dispatch(alertActions.error(res.data.message || "Failed to create shipping rate."));
          }
        })
        .catch((err) => {
          dispatch(alertActions.error(err.response?.data?.message || "Failed to create shipping rate."));
        })
    );
  };
}

function updateShippingRate(rateId, data) {
  return (dispatch) => {
    return trackPromise(
      axios
        .put(`${API_BASE_URL}/admin/shipping-rates/${rateId}/`, data)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.UPDATE_SHIPPING_RATE,
              payload: res.data.rate,
            });
            dispatch(alertActions.success(res.data.message));
          } else {
            dispatch(alertActions.error(res.data.message || "Failed to update shipping rate."));
          }
        })
        .catch((err) => {
          dispatch(alertActions.error(err.response?.data?.message || "Failed to update shipping rate."));
        })
    );
  };
}

function deleteShippingRate(rateId) {
  return (dispatch) => {
    return trackPromise(
      axios
        .delete(`${API_BASE_URL}/admin/shipping-rates/${rateId}/`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.DELETE_SHIPPING_RATE,
              payload: rateId,
            });
            dispatch(alertActions.success(res.data.message));
          } else {
            dispatch(alertActions.error(res.data.message || "Failed to delete shipping rate."));
          }
        })
        .catch((err) => {
          dispatch(alertActions.error(err.response?.data?.message || "Failed to delete shipping rate."));
        })
    );
  };
}

// ─── Return / Refund Request Actions ────────────────────────────────────

function getBuyerReturns() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/orders/returns/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_BUYER_RETURNS,
            returns: res.data.returns,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function createReturnRequest(data) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/orders/returns/`, data)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.CREATE_RETURN_REQUEST,
            return_request: res.data.return_request,
          });
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

function getSellerReturns() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/seller/returns/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_SELLER_RETURNS,
            returns: res.data.returns,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function respondToReturn(returnId, action, sellerResponse, refundAmount) {
  return (dispatch) => {
    return axios
      .put(`${API_BASE_URL}/seller/returns/${returnId}/`, {
        action,
        seller_response: sellerResponse,
        refund_amount: refundAmount,
      })
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.RESPOND_TO_RETURN,
            return_request: res.data.return_request,
          });
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

function confirmReturnReceipt(returnId) {
  return (dispatch) => {
    return axios
      .put(`${API_BASE_URL}/seller/returns/${returnId}/confirm-receipt/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.RESPOND_TO_RETURN,
            return_request: res.data.return_request,
          });
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

function uploadReturnEvidence(returnId, photos) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/returns/${returnId}/evidence/`, { photos })
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

// ─── Product Subscriptions (Recurring Orders) ────────────────────────────

function getSubscriptions() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/subscriptions/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_SUBSCRIPTIONS,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        console.error("getSubscriptions error:", err);
      });
  };
}

function createSubscription(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/subscriptions/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.CREATE_SUBSCRIPTION,
            payload: res.data,
          });
          dispatch(alertActions.success(res.data.message));
        } else {
          dispatch(alertActions.error(res.data.message || "Failed to create subscription."));
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || "Failed to create subscription.";
        dispatch(alertActions.error(typeof msg === "string" ? msg : JSON.stringify(msg)));
      });
  };
}

function updateSubscription(subscriptionId, payload) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/subscriptions/${subscriptionId}/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.UPDATE_SUBSCRIPTION,
            payload: res.data,
          });
          dispatch(alertActions.success(res.data.message));
        } else {
          dispatch(alertActions.error(res.data.message || "Failed to update subscription."));
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || "Failed to update subscription.";
        dispatch(alertActions.error(typeof msg === "string" ? msg : JSON.stringify(msg)));
      });
  };
}

function cancelSubscription(subscriptionId) {
  return (dispatch) => {
    axios
      .delete(`${API_BASE_URL}/subscriptions/${subscriptionId}/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.CANCEL_SUBSCRIPTION,
            payload: { id: subscriptionId },
          });
          dispatch(alertActions.success(res.data.message));
        } else {
          dispatch(alertActions.error(res.data.message || "Failed to cancel subscription."));
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || "Failed to cancel subscription.";
        dispatch(alertActions.error(typeof msg === "string" ? msg : JSON.stringify(msg)));
      });
  };
}

function getPriceAlerts() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/user/price-alerts/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_PRICE_ALERTS,
            payload: res.data,
          });
        }
      })
      .catch(() => {});
  };
}

function setPriceAlert(slug, target_price) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/products/${slug}/price-alert/`, { target_price })
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.SET_PRICE_ALERT,
            payload: res.data,
          });
          dispatch(alertActions.success(res.data.message));
        } else {
          dispatch(alertActions.error(res.data.message || "Failed to set price alert."));
        }
      })
      .catch((e) => {
        const msg = e?.response?.data?.message || "Failed to set price alert.";
        dispatch(alertActions.error(msg));
      });
  };
}

function removePriceAlert(slug) {
  return (dispatch) => {
    axios
      .delete(`${API_BASE_URL}/products/${slug}/price-alert/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.REMOVE_PRICE_ALERT,
            payload: { slug },
          });
          dispatch(alertActions.success(res.data.message));
        }
      })
      .catch((e) => {
        const msg = e?.response?.data?.message || "Failed to remove price alert.";
        dispatch(alertActions.error(msg));
      });
  };
}

function getPriceAlertStatus(slug) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/products/${slug}/price-alert/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_PRICE_ALERT_STATUS,
            payload: res.data,
          });
        }
      })
      .catch(() => {});
  };
}

// ==================== Landing Page Redesign Actions ====================

function getHomepageAd() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/ads/homepage/`)
      .then((res) => {
        dispatch({
          type: userConstants.GET_HOMEPAGE_AD,
          payload: res.data.data,
        });
      })
      .catch((err) => {
        console.error("getHomepageAd error:", err);
      });
  };
}

function recordAdClick(adId) {
  return () => {
    axios
      .post(`${API_BASE_URL}/ads/click/${adId}/`)
      .catch((err) => {
        console.error("recordAdClick error:", err);
      });
  };
}

function getBestSellers() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/products/best-sellers/`)
      .then((res) => {
        dispatch({
          type: userConstants.GET_BEST_SELLERS,
          payload: res.data.products,
        });
      })
      .catch((err) => {
        console.error("getBestSellers error:", err);
      });
  };
}

function getRecommendedProducts(categoryIds) {
  return (dispatch) => {
    const params = categoryIds ? `?categories=${categoryIds}` : '';
    axios
      .get(`${API_BASE_URL}/products/recommended/${params}`)
      .then((res) => {
        dispatch({
          type: userConstants.GET_RECOMMENDED_PRODUCTS,
          payload: {
            products: res.data.products,
            personalized: res.data.personalized,
          },
        });
      })
      .catch((err) => {
        console.error("getRecommendedProducts error:", err);
      });
  };
}

function getActiveCampaigns() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/sponsorship/active-campaigns/`)
      .then((res) => {
        dispatch({
          type: userConstants.GET_ACTIVE_CAMPAIGNS,
          payload: res.data.campaigns,
        });
      })
      .catch((err) => {
        console.error("getActiveCampaigns error:", err);
      });
  };
}

function getSuccessStories() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/sponsorship/success-stories/`)
      .then((res) => {
        dispatch({
          type: userConstants.GET_SUCCESS_STORIES,
          payload: res.data.stories,
        });
      })
      .catch((err) => {
        console.error("getSuccessStories error:", err);
      });
  };
}

function getOrderTracking(orderId) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/orders/${orderId}/tracking/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_ORDER_TRACKING,
            payload: res.data.tracking,
          });
        }
      })
      .catch((err) => {
        console.error("getOrderTracking error:", err);
      });
  };
}

function updateOrderTracking(orderId, payload) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/orders/${orderId}/tracking/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.UPDATE_ORDER_TRACKING,
            payload: res.data.tracking,
          });
          dispatch(alertActions.success(res.data.message || "Tracking saved"));
        } else {
          throw res.data.message || "Failed to save tracking";
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err?.response?.data?.message || err.toString()));
      });
  };
}

function confirmDelivery(orderId) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/orders/${orderId}/confirm-delivery/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.CONFIRM_DELIVERY,
            payload: { orderId },
          });
          dispatch(alertActions.success(res.data.message || "Delivery confirmed"));
        } else {
          throw res.data.message || "Failed to confirm delivery";
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err?.response?.data?.message || err.toString()));
      });
  };
}

// ─── RFQ (Request for Quote) Actions ─────────────────────────────────────

function getBuyerRfqs() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/rfq/my/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_BUYER_RFQS,
            rfqs: res.data.rfqs,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function createRfq(payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/rfq/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.CREATE_RFQ,
            rfq: res.data.rfq,
          });
        } else {
          throw res.data.message || "Failed to create RFQ";
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function getRfqDetail(rfqId) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/rfq/${rfqId}/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_RFQ_DETAIL,
            rfq: res.data.rfq,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function getRfqQuotes(rfqId) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/rfq/${rfqId}/quotes/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_RFQ_QUOTES,
            quotes: res.data.quotes,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function getManufacturerRfqs() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/rfq/manufacturer-list/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_MANUFACTURER_RFQS,
            rfqs: res.data.rfqs,
          });
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function submitRfqQuote(rfqId, payload) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/rfq/${rfqId}/quote/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.SUBMIT_RFQ_QUOTE,
            rfqId: rfqId,
            quote: res.data.quote,
          });
        } else {
          throw res.data.message || "Failed to submit quote";
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function acceptRfqQuote(quoteId) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/rfq/quote/${quoteId}/accept/`)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.ACCEPT_RFQ_QUOTE,
            quote: res.data.quote,
          });
        } else {
          throw res.data.message || "Failed to accept quote";
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function rejectRfqQuote(quoteId) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/rfq/quote/${quoteId}/reject/`)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.REJECT_RFQ_QUOTE,
            quote: res.data.quote,
          });
        } else {
          throw res.data.message || "Failed to reject quote";
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function signRfqNda(rfqId) {
  return (dispatch) => {
    axios
      .post(`${API_BASE_URL}/rfq/${rfqId}/sign-nda/`)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success(res.data.message));
          dispatch({
            type: userConstants.SIGN_RFQ_NDA,
            rfq: res.data.rfq,
          });
        } else {
          throw res.data.message || "Failed to sign NDA";
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || err;
        dispatch(alertActions.error(msg));
      });
  };
}

function getRfqPriceSuggestion(categoryId) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/rfq/price-suggestion/?category_id=${categoryId}`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_RFQ_PRICE_SUGGESTION,
            suggestion: res.data,
          });
        }
      })
      .catch((err) => {
        console.error("Price suggestion error:", err);
      });
  };
}

// ── Buyer Onboarding Wizard ──

function getBuyerOnboardingWizardStatus() {
  return (dispatch) => {
    dispatch({ type: "BUYER_ONBOARDING_WIZARD_LOADING" });
    axios
      .get(`${API_BASE_URL}/user/onboarding-status/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: "BUYER_ONBOARDING_WIZARD_LOADED",
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        console.error("getBuyerOnboardingWizardStatus error:", err);
        dispatch({ type: "BUYER_ONBOARDING_WIZARD_ERROR" });
      });
  };
}

function updateBuyerOnboardingStep(step) {
  return (dispatch) => {
    dispatch({ type: "BUYER_ONBOARDING_WIZARD_STEP", payload: step });
    axios
      .put(`${API_BASE_URL}/user/onboarding-step/`, { step })
      .catch((err) => {
        console.error("updateBuyerOnboardingStep error:", err);
      });
  };
}

function completeBuyerOnboarding() {
  return (dispatch) => {
    dispatch({ type: "BUYER_ONBOARDING_WIZARD_COMPLETED" });
    axios
      .post(`${API_BASE_URL}/user/onboarding-complete/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: "BUYER_ONBOARDING_WIZARD_COMPLETED_OK",
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        console.error("completeBuyerOnboarding error:", err);
      });
  };
}

// Seller Analytics (comprehensive)
function getSellerAnalytics() {
  return (dispatch) => {
    trackPromise(
      axios
        .get(`${API_BASE_URL}/dashboard/seller/analytics/`)
        .then((res) => {
          if (res.data.status) {
            dispatch({
              type: userConstants.GET_SELLER_ANALYTICS,
              payload: res.data,
            });
          }
        })
        .catch((err) => {
          console.error("getSellerAnalytics error:", err);
        })
    );
  };
}

function getFeaturedBundles() {
  return (dispatch) => {
    axios.get(`${API_BASE_URL}/bundles/featured/`).then((resp) => {
      if (resp.data.status) {
        dispatch({
          type: userConstants.GET_FEATURED_BUNDLES,
          payload: resp.data.bundles,
        });
      }
    }).catch(() => {});
  };
}

function getFrequentlyBoughtTogether(slug) {
  return (dispatch) => {
    axios.get(`${API_BASE_URL}/products/${slug}/frequently-bought-together/`).then((resp) => {
      if (resp.data.status) {
        dispatch({
          type: userConstants.GET_FREQUENTLY_BOUGHT_TOGETHER,
          payload: resp.data.products,
        });
      }
    }).catch(() => {});
  };
}

function getRelatedProductsSeller(slug) {
  return (dispatch) => {
    axios.get(`${API_BASE_URL}/products/${slug}/related/`).then((resp) => {
      if (resp.data.status) {
        dispatch({
          type: userConstants.GET_RELATED_PRODUCTS_SELLER,
          payload: resp.data.products,
        });
      }
    }).catch(() => {});
  };
}

function updateSellerBundle(bundleId, payload) {
  return (dispatch) => {
    axios
      .put(`${API_BASE_URL}/seller/bundles/${bundleId}/`, payload)
      .then((res) => {
        if (res.data.status) {
          dispatch(alertActions.success("Bundle updated successfully"));
          dispatch(getSellerBundles());
        } else {
          dispatch(alertActions.error(res.data.message || "Failed to update bundle"));
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err?.response?.data?.message || "Failed to update bundle"));
      });
  };
}

function showUpsellPopup(products) {
  return { type: userConstants.SHOW_UPSELL_POPUP, payload: products };
}

function hideUpsellPopup() {
  return { type: userConstants.HIDE_UPSELL_POPUP };
}

// ── Wishlist Folders ──────────────────────────────────────────────

function getWishlistFolders() {
  return (dispatch) => {
    axios.get(`${API_BASE_URL}/wishlist/folders/`).then((res) => {
      if (res.data.status) {
        dispatch({
          type: userConstants.GET_WISHLIST_FOLDERS,
          payload: res.data,
        });
      }
    }).catch(() => {});
  };
}

function createWishlistFolder(name) {
  return (dispatch) => {
    axios.post(`${API_BASE_URL}/wishlist/folders/`, { name }).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success(res.data.message || "Folder created"));
        dispatch(getWishlistFolders());
      } else {
        dispatch(alertActions.error(res.data.message || "Failed to create folder"));
      }
    }).catch((err) => {
      dispatch(alertActions.error(err?.response?.data?.message || "Failed to create folder"));
    });
  };
}

function updateWishlistFolder(folderId, data) {
  return (dispatch) => {
    axios.put(`${API_BASE_URL}/wishlist/folders/`, { folder_id: folderId, ...data }).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success(res.data.message || "Folder updated"));
        dispatch(getWishlistFolders());
      } else {
        dispatch(alertActions.error(res.data.message || "Failed to update folder"));
      }
    }).catch((err) => {
      dispatch(alertActions.error(err?.response?.data?.message || "Failed to update folder"));
    });
  };
}

function deleteWishlistFolder(folderId) {
  return (dispatch) => {
    axios.delete(`${API_BASE_URL}/wishlist/folders/`, { data: { folder_id: folderId } }).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success("Folder deleted"));
        dispatch(getWishlistFolders());
        dispatch(getWishList());
      }
    }).catch(() => {});
  };
}

function moveWishlistItem(itemId, folderId) {
  return (dispatch) => {
    axios.put(`${API_BASE_URL}/wishlist/${itemId}/move/`, { folder_id: folderId }).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success("Item moved"));
        dispatch(getWishList());
        dispatch(getWishlistFolders());
      }
    }).catch(() => {});
  };
}

function bulkAddToCart(folderId, cartToken) {
  return (dispatch) => {
    axios.post(`${API_BASE_URL}/wishlist/bulk-add-to-cart/`, {
      folder_id: folderId,
      cart_token: cartToken,
    }).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success(res.data.message));
        dispatch({ type: userConstants.BULK_ADD_TO_CART, payload: res.data });
        dispatch(userActions.getCartDetails(cartToken));
      } else {
        dispatch(alertActions.error(res.data.message || "Failed to add items"));
      }
    }).catch((err) => {
      dispatch(alertActions.error(err?.response?.data?.message || "Failed to add items to cart"));
    });
  };
}

function getSellerWishlistAnalytics() {
  return (dispatch) => {
    axios.get(`${API_BASE_URL}/seller/wishlist-analytics/`).then((res) => {
      if (res.data.status) {
        dispatch({
          type: userConstants.GET_SELLER_WISHLIST_ANALYTICS,
          payload: res.data.analytics,
        });
      }
    }).catch(() => {});
  };
}

function getLoyaltyTransactions(page = 1) {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/user/loyalty/transactions/?page=${page}`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_LOYALTY_TRANSACTIONS,
            payload: res.data,
          });
        }
      })
      .catch(() => {});
  };
}

function redeemLoyaltyPoints(points) {
  return (dispatch) => {
    return axios
      .post(`${API_BASE_URL}/user/loyalty/redeem/`, { points })
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.LOYALTY_REDEEM,
            payload: res.data,
          });
          dispatch(alertActions.success(res.data.message));
          dispatch(getBuyerLoyalty());
        } else {
          dispatch(alertActions.error(res.data.message));
        }
        return res.data;
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || "Failed to redeem points.";
        dispatch(alertActions.error(msg));
        throw err;
      });
  };
}

function getLoyaltyDashboard() {
  return (dispatch) => {
    axios
      .get(`${API_BASE_URL}/user/loyalty/dashboard/`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: userConstants.GET_LOYALTY_DASHBOARD,
            payload: res.data,
          });
        }
      })
      .catch(() => {});
  };
}

function bulkUpdateOrderStatus(orderIds, status) {
  return (dispatch) => {
    axios.post(`${API_BASE_URL}/orders/seller/orders/bulk-status/`, { order_ids: orderIds, status: status }).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success(res.data.message || "Orders updated"));
        dispatch(getSellerOrders());
      } else {
        dispatch(alertActions.error(res.data.message || "Failed to update orders"));
      }
    }).catch((err) => {
      dispatch(alertActions.error(err?.response?.data?.message || "Failed to update orders"));
    });
  };
}

function updateOrderNotes(orderId, notes) {
  return (dispatch) => {
    axios.put(`${API_BASE_URL}/orders/orders/${orderId}/notes/`, notes).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success("Notes updated"));
      } else {
        dispatch(alertActions.error(res.data.message || "Failed to update notes"));
      }
    }).catch((err) => {
      dispatch(alertActions.error(err?.response?.data?.message || "Failed to update notes"));
    });
  };
}

function reorderItems(orderId, cartToken) {
  return (dispatch) => {
    axios.post(`${API_BASE_URL}/orders/orders/${orderId}/reorder/`, { cart_token: cartToken || "" }).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success(res.data.message || "Items added to cart"));
        if (res.data.cart_token) {
          localStorage.setItem("anonymous_cart_token", res.data.cart_token);
        }
      } else {
        dispatch(alertActions.error(res.data.message || "Failed to reorder"));
      }
    }).catch((err) => {
      dispatch(alertActions.error(err?.response?.data?.message || "Failed to reorder"));
    });
  };
}

function cancelOrder(orderId, reason) {
  return (dispatch) => {
    axios.post(`${API_BASE_URL}/orders/orders/${orderId}/cancel/`, { reason: reason || "" }).then((res) => {
      if (res.data.status) {
        dispatch(alertActions.success(res.data.message || "Order cancelled"));
        dispatch(getOrderItem());
      } else {
        dispatch(alertActions.error(res.data.message || "Failed to cancel order"));
      }
    }).catch((err) => {
      dispatch(alertActions.error(err?.response?.data?.message || "Failed to cancel order"));
    });
  };
}

function getCancelStatus(orderId) {
  return (dispatch) => {
    axios.get(`${API_BASE_URL}/orders/orders/${orderId}/cancel/`).then((res) => {
      dispatch({ type: userConstants.GET_CANCEL_STATUS, payload: { orderId, ...res.data } });
    }).catch(() => {});
  };
}

function sellerExportOrders(dateFrom, dateTo) {
  const token = localStorage.getItem("token") || "";
  const params = new URLSearchParams();
  params.set("token", token);
  if (dateFrom) params.set("from", dateFrom);
  if (dateTo) params.set("to", dateTo);
  const url = `${API_BASE_URL}/orders/seller/orders/export/?${params.toString()}`;
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "seller_orders_export.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return { type: "NOOP" };
}